import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
const ImageSkeleton = (setting) => {
    return  <Skeleton height={200} style={{display:setting.style_}} />
}

export default ImageSkeleton 